export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I'm a tech enthusiast and coding aficionado currently studying
            for my B.Tech. I'm deeply passionate about graphic design, 
            web development, and mastering languages like C and Python.
          </p>
          <p className="hero--section-description">
            Always eager to learn, I thrive on exploring new challenges and 
            pushing the boundaries of what's possible in the digital world.
          </p>
        </div>
      </div>
    </section>
  );
}
